import { gql } from '@apollo/client'

export const CHAT_INBOX = gql`
  query ChatInbox(
    $mode: String
    $unread: Boolean
    $tags: [Int]
    $dateFrom: String
    $dateTo: String
    $search: String
    $assignedUserId: Int
    $organizationId: Int
    $offset: Int
    $limit: Int
  ) {
    chatInbox(
      mode: $mode
      unread: $unread
      tags: $tags
      dateFrom: $dateFrom
      dateTo: $dateTo
      search: $search
      assignedUserId: $assignedUserId
      organizationId: $organizationId
      offset: $offset
      limit: $limit
    ) {
      items {
        id
        fullName
        phone
        avatar
        unreadCount
        assignedTo
        assignedToName
        configSource
        activeChannels
        activeChannelsDetail {
          channelType
          phoneNumber
        }
        lastMessage {
          content
          createdAt
          direction
          channel
          receivedViaChannel {
            id
            provider
            channelType
            phoneNumber
            webhookToken
          }
        }
        tags {
          id
          name
          color
        }
      }
      total
      configSource
      whatsappUnread
      smsUnread
    }
  }
`

export const CHAT_HISTORY = gql`
  query ChatHistory($contactId: Int!) {
    chatHistory(contactId: $contactId) {
      messages {
        id
        direction
        content
        status
        createdAt
        channel
        metadata
        receivedViaChannel {
          id
          provider
          channelType
          phoneNumber
          webhookToken
        }
      }
      total
      configSource
    }
  }
`

export const CHAT_TAGS = gql`
  query ChatTags($organizationId: Int) {
    chatTags(organizationId: $organizationId) {
      id
      name
      color
    }
  }
`

export const AVAILABLE_CHANNELS = gql`
  query AvailableChannels {
    availableChannels {
      id
      source
      label
      type
      whatsappNumber
      smsNumber
      isDefault
    }
  }
`

export const INBOX_USERS = gql`
  query InboxUsers($organizationId: Int) {
    inboxUsers(organizationId: $organizationId) {
      id
      fullName
      email
    }
  }
`

// ── CRM context panel (right pane) ────────────────────────────────────────
export const CONTACT_CRM_PANEL = gql`
  query ContactCrmPanel($id: String!) {
    contactById(id: $id) {
      id
      fullName
      email
      phone
      user {
        id
        firstName
        lastName
        email
        avatar
      }
      lead {
        id
        name
        stagePipeline {
          id
          name
          pipeline {
            id
            name
          }
        }
      }
      memberPolicy {
        id
        policy {
          id
          policyName
          status
          effectiveDate
          type
        }
      }
      members {
        edges {
          node {
            id
            policy {
              id
              policyName
              status
              effectiveDate
              type
            }
          }
        }
      }
    }
  }
`

export const CONTACT_TICKETS = gql`
  query ContactTickets($contactId: ID!) {
    tickets(contactId: $contactId, includeSolvedClosed: false, first: 10) {
      totalCount
      items {
        id
        title
        status
        priority
        assignedGroup {
          id
          name
        }
      }
    }
  }
`

export const CONTACT_CALLS = gql`
  query contactCalls($contactId: String) {
    allCommunications(first: 20, contact: $contactId, channel: "CALL") {
      edges {
        node {
          id
          direction
          created
          user {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`
